import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken, clearToken, isTokenExpired } from '../dppApi';
import ManageCatalogue from './ManageCatalogue';
import '../App.css';

const bloomMark = process.env.PUBLIC_URL + '/BloomFavicon.png';

// Full-page Manage Catalogue: reached from the dashboard's "Manage Catalogue"
// link. Wraps the reusable import panel (CSV / JSON / manual) with page chrome.
const ManageCataloguePage = () => {
    const navigate = useNavigate();
    const token = getToken('brand');

    useEffect(() => {
        if (!token || isTokenExpired(token)) { clearToken('brand'); navigate('/brand'); }
    }, [token, navigate]);

    return (
        <div className="dpp-page">
            <div className="collection-topbar">
                <div className="collection-topbar-brand">
                    <img className="dpp-brand-mark" src={bloomMark} alt="Bloom" />
                    <h1 className="collection-topbar-title">Manage Catalogue</h1>
                </div>
                <div className="dpp-header-actions">
                    <button className="dpp-link-button" onClick={() => navigate('/brand/dashboard')}>Back to dashboard</button>
                </div>
            </div>

            <div style={{ maxWidth: 960, margin: '0 auto' }}>
                <ManageCatalogue token={token} onImported={() => {}} />
            </div>
        </div>
    );
};

export default ManageCataloguePage;
